"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Executor = exports.ExecutorClass = exports.ExecutorModes = exports.ExecutorStatus = void 0;
const jsonschema_1 = require("jsonschema");
const schema_json_1 = __importDefault(require("../schema.json"));
const Extras_1 = __importDefault(require("./Extras"));
const Lesson_1 = require("./Lesson");
const Logger_1 = require("./Logger");
const types_1 = require("./types");
const utils_1 = require("./utils");
var ExecutorStatus;
(function (ExecutorStatus) {
    ExecutorStatus["NotLoaded"] = "notLoaded";
    ExecutorStatus["LessonLoaded"] = "lessonLoaded";
    ExecutorStatus["Error"] = "error";
    ExecutorStatus["LessonStarted"] = "lessonStarted";
    ExecutorStatus["LessonCompleted"] = "lessonCompleted";
})(ExecutorStatus = exports.ExecutorStatus || (exports.ExecutorStatus = {}));
var ExecutorModes;
(function (ExecutorModes) {
    ExecutorModes["DEMO"] = "demo";
    ExecutorModes["GUIDED"] = "guided";
    ExecutorModes["MANUAL"] = "manual";
})(ExecutorModes = exports.ExecutorModes || (exports.ExecutorModes = {}));
class ExecutorClass {
    constructor() {
        this.lessonTimedOut = null;
        // private status = ExecutorStatus.NotLoaded;
        this.extras = new Extras_1.default();
        this.fn = () => { };
    }
    migrate(oldJson) {
        return utils_1.migrate(oldJson);
    }
    replay(lessonLog) {
        try {
            const lessonLevelLogs = lessonLog.filter((log) => log.level === Logger_1.LogLevel.LESSON);
            if (lessonLevelLogs.length === 0) {
                this.extras.logger.error({
                    message: 'Not actions to replay',
                });
                return;
            }
            this.extras.logger.info({
                message: `Starting replay mode`,
            });
            lessonLevelLogs.forEach((logItem, index) => {
                let lastLogTime = lessonLevelLogs[Math.max(index - 1, 0)].time;
                if (logItem.time - lastLogTime > 0) {
                    this.extras.doEmitDelay(logItem.time - lastLogTime);
                }
                this.extras.doActionEmit(logItem.payload);
            });
            this.extras.lessonComplete();
            this.extras.logger.info({
                message: `Completed replay mode`,
            });
        }
        catch (err) {
            console.log(err);
        }
    }
    load(lessonDef) {
        try {
            if (this.extras.executorStatus !== ExecutorStatus.NotLoaded) {
                throw new Error(`Please reset executor to load new lesson.`);
            }
            const v = new jsonschema_1.Validator();
            const result = v.validate(lessonDef, schema_json_1.default);
            if (!result.valid) {
                this.extras.executorStatus = ExecutorStatus.Error;
                throw new Error(`Schema validation error. ${result.toString()}`);
            }
            this.lesson = new Lesson_1.Lesson(lessonDef, this.extras);
            this.extras.executorStatus = ExecutorStatus.LessonLoaded;
            console.log('Initialized', this);
            // console.log('node order', this.structure.getNodeOrderForDemo([]));
            return {
                loaded: true,
                reason: '',
            };
        }
        catch (err) {
            this.extras.executorStatus = ExecutorStatus.Error;
            return {
                loaded: false,
                reason: err,
            };
        }
    }
    validate(val) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (this.extras.executorStatus !== ExecutorStatus.LessonStarted) {
                    this.extras.doControlEmit(types_1.ControlActions.Error, `Lesson not started or loaded with error`);
                    return;
                }
                this.extras.logger.lessonLog({
                    inputAction: true,
                    input: val,
                });
                const result = yield this.lesson.validate(val);
                this.extras.logger.lmsLog({
                    inputAction: true,
                    input: val,
                    isValid: result,
                });
                return {
                    result,
                    reason: result ? 'Ok' : 'Invalid Input paramters',
                };
            }
            catch (err) {
                console.error('Exception caught', err);
                return {
                    result: false,
                    reason: err.toString(),
                };
            }
        });
    }
    reset() {
        this.extras.executorStatus = ExecutorStatus.NotLoaded;
        this.lesson && this.lesson.reset();
    }
    onLessonTimeOut() {
        if (this.extras.executorStatus !== ExecutorStatus.LessonCompleted &&
            this.extras.mode !== ExecutorModes.DEMO) {
            this.extras.doControlEmit(types_1.ControlActions.LessonTimedOut, 'Lesson TimedOut');
        }
        else {
            if (this.lessonTimedOut) {
                clearTimeout(+this.lessonTimedOut);
            }
        }
    }
    start(role, mode) {
        try {
            if (this.lessonTimedOut) {
                clearTimeout(+this.lessonTimedOut);
            }
            if (this.extras.executorStatus !== ExecutorStatus.LessonLoaded) {
                this.extras.doControlEmit(types_1.ControlActions.Error, `Lesson not loaded or loaded with error`);
                return {
                    started: false,
                    reason: `Lesson not loaded or loaded with erro`,
                };
            }
            this.extras.executorStatus = ExecutorStatus.LessonStarted;
            this.extras.role = role;
            this.extras.mode = mode;
            this.extras.logger.setLessonStart();
            this.lesson.start();
            this.lessonTimedOut = setTimeout(() => this.onLessonTimeOut(), this.lesson.estimatedTime * 60 * 1000);
            return {
                started: true,
                reason: 'ok',
            };
        }
        catch (err) {
            this.extras.doControlEmit(types_1.ControlActions.Error, err);
            return {
                started: false,
                reason: err,
            };
        }
    }
    onActionEmit(fn) {
        this.extras.onActionEmit = fn;
    }
    onLog(fn) {
        this.extras.logger.logListener = fn;
    }
    getLog(level) {
        return this.extras.logger.getLogs(level);
    }
    getHelp() {
        console.log('getHelp', this.extras.executorStatus);
        if (this.extras.executorStatus === ExecutorStatus.LessonLoaded ||
            this.extras.executorStatus === ExecutorStatus.LessonStarted) {
            return this.lesson.getHelp();
        }
        else {
            return this.extras.doControlEmit(types_1.ControlActions.Error, `Lesson not loaded or in error, no help available`);
        }
    }
}
exports.ExecutorClass = ExecutorClass;
exports.Executor = new ExecutorClass();
//# sourceMappingURL=data:application/json;base64,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